import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Document16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3 0.25C2.30964 0.25 1.75 0.809643 1.75 1.5V14.5C1.75 15.1904 2.30964 15.75 3 15.75L13 15.75C13.6904 15.75 14.25 15.1904 14.25 14.5V5.14695C14.25 4.81202 14.1156 4.4911 13.8769 4.25614L10.1721 0.609188C9.93826 0.37901 9.62331 0.25 9.29519 0.25H3ZM3.25 14.25V1.75H8.25V5.5C8.25 5.91421 8.58579 6.25 9 6.25H12.75V14.25L3.25 14.25ZM12.2404 4.75L9.75 2.29851V4.75H12.2404Z'
      fill='currentColor'
    />
  </Svg>
);

Document16.displayName = 'Document16';
export default Document16;
